import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var OralPathRad = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.42.05a8.474 8.474 0 0 0-8.481 8.48c0 1.996.698 3.892 1.895 5.289l-5.088 5.088c-.898-.698-2.095-.798-3.093-.2L14.068 22.5c-.599.3-1.197.798-1.696 1.297L.599 35.469a2.047 2.047 0 0 0 0 2.894l4.988 4.988a2.047 2.047 0 0 0 2.894 0l11.773-11.773c.499-.499.898-1.097 1.297-1.696l3.791-6.685c.599-.997.5-2.195-.2-3.093l5.09-5.088c1.496 1.197 3.292 1.896 5.287 1.896C40.21 16.912 44 13.12 44 8.43 43.9 3.84 40.109.05 35.42.05ZM23.745 22.399l-3.791 6.585c-.3.499-.599.898-.998 1.297L7.184 42.054c-.1.1-.2.1-.3 0l-4.988-4.988c-.1-.1-.1-.2 0-.3l11.773-11.773c.399-.399.798-.698 1.297-.998l6.585-3.791c.4-.2.798-.2 1.098.2l.898.898c.199.2.299.399.299.698 0 .1-.1.2-.1.399Zm6.884-9.279c-.399-.399-1.097-1.297-1.496-2.494 0 0-.4-1.098-.4-2.095a6.685 6.685 0 1 1 6.685 6.684c-.997 0-1.995-.299-1.995-.299a6.575 6.575 0 0 1-2.694-1.596c0-.1 0-.1-.1-.2Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.712 11.823c-1.796 1.796-4.79 1.796-6.585 0-.4-.3-.4-.898 0-1.297.4-.4.898-.4 1.297 0 1.098 1.098 2.894 1.098 4.09 0 .4-.4.899-.4 1.298 0 .3.4.3.898-.1 1.297Z"
  }));
});
OralPathRad.displayName = 'OralPathRad';
OralPathRad.defaultProps = {
  'aria-label': 'OralPathRad'
};
export default OralPathRad;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/OralPathRad.js
// module id = 3055
// module chunks = 11